export default "__VITE_ASSET__CXixNvEd__"